import React, {Component} from 'react';

class Pagination extends Component {
  render() {

    const {currentPage, pagination, totalPages, pageNumbers, onPaginationClick, location} = this.props;

    const scrollPagination = (click) => {
      window.scrollTo(0, 0)
      onPaginationClick(click)
    }

    return (
      <div className="theme-pagination" aria-label="Page navigation">
        <ul className="pagination-list">

          {
            (currentPage == 1 || (location && location.pathname.includes('/members')) )  ? null : (
              <li>
                <span className="pagi-begin" onClick={ () => scrollPagination(1) }>&laquo;</span>
              </li>
            )
          }

          {
            pagination.prevPage < 1 ? null : (
              <li>
                <span className="pagi-prev"
                      onClick={ () => scrollPagination(pagination.prevPage) }>&lsaquo;</span>
              </li>
            )
          }

          {
            pageNumbers.map((page, index) => {
              return (
                <li key={ index } className={ page == currentPage ? 'active' : '' }>
                  <span className="pages" onClick={ () => scrollPagination(page) }>{ page }</span>
                </li>
              );
            })
          }

          {
            pagination.nextPage > totalPages ? null : (
              <li>
                <span className="pagi-next"
                      onClick={ () => scrollPagination(pagination.nextPage) }>&rsaquo;</span>
              </li>
            )
          }

         {
            currentPage == totalPages || (location && location.pathname.includes('/members')) ? null : (
              <li>
                <span className="pagi-end"
                      onClick={ () => scrollPagination(totalPages) }>&raquo;</span>
              </li>
            )
          }
        </ul>
      </div>
    );
  }
}

export default Pagination;




// WEBPACK FOOTER //
// src/client/components/common/elements/Pagination.js